import { BaseRequest } from '@/network/requests/BaseRequest';
import {color_info} from '@/interfaces/color_info'

export const colorInfoRequest = BaseRequest.build<color_info>(`color_info`);
